import React from 'react';
import { ReactTyped } from 'react-typed';
import { Experience, Skill, SkillsInfo } from '../utils/resource.utils';
import ScrollAnimatedItem from '../utils/ScrollAnimatedItem';

const About = () => {

  const aboutTexts = [
    `Hi! I'm currently a Software Engineer at IBM and a recent Computer Science graduate from the Indian Institute of Information Technology Kottayam, Kerala, India.`,
    `As a full-stack developer with a focus on Spring Boot and MERN stack, I enjoy designing and building clean, scalable web applications. I’m currently diving deeper into cloud technologies to master platforms like AWS and GCP.`,
    `Beyond work, I’m a passionate open-source enthusiast. I love contributing to meaningful projects, collaborating with developers from around the world, and learning through hands-on experience.`
  ];

  return (
    <div className="md:mt-10 mb-5 justify-center transition-colors select-none" id="about">
      {/* Header Section */}
      <div className="px-3 md:mx-auto">
        <p className="mt-2 text-3xl font-bold tracking-tight text-indigo-500 md:text-4xl lg:text-5xl mb-4 text-center dark:text-slate-200">
          <ReactTyped
            strings={[
              `I focus on building <span class='bg-gradient-to-r from-[#ff80b5] to-[#9089fc] bg-clip-text text-transparent'>quality</span> applications and services`,
            ]}
            typeSpeed={50}
            backSpeed={50}
            showCursor={false}
            smartBackspace
            loop={false}
          />
        </p>
      </div>

      {/* About + Skills Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-1 lg:gap-2 items-center justify-center py-3 transition-all">
        <div className="mx-5">
          {aboutTexts.map((text, index) => (
            <ScrollAnimatedItem key={index} custom={index} triggerOnce={true}>
              <p className="mt-3 text-[18px] lg:text-[19px] leading-8 text-gray-700 mx-2 my-5 dark:text-slate-300 transition-opacity">
                {text}
              </p>
            </ScrollAnimatedItem>
          ))}

          {/* Resume Button */}
          <ScrollAnimatedItem custom={aboutTexts.length} triggerOnce={true}>
            <span className="md:hidden block text-center w-fit cursor-pointer border dark:border-slate-300 mx-auto py-2 rounded-lg bg-black hover:bg-gray-800 text-white dark:bg-slate-100 dark:hover:bg-gray-900 transition-all">
              <a
                className="md:text-lg px-3 py-2 font-medium dark:hover:text-white dark:text-black transition-transform ease-in-out"
                href="https://drive.google.com/file/d/13cT-T9LbNYYCtnlzhfSrnJuGoCOF3ifo/view?usp=sharing"
                rel="noreferrer"
                target="_blank"
              >
                View Resume
              </a>
            </span>
          </ScrollAnimatedItem>
        </div>

        {/* Skills Section */}
        <div className="border border-slate-300 hover:shadow-sm mx-5 my-4 p-5 md:px-10 dark:border-dotted dark:bg-black rounded-lg dark:border-slate-700 transition-all">
          <div className="space-y-4">
            {SkillsInfo.map((skill, index) => (
              <ScrollAnimatedItem key={skill.title} custom={index} triggerOnce={true}>
                <Skill title={skill.title} content={skill.content} />
              </ScrollAnimatedItem>
            ))}
          </div>
        </div>
      </div>

      {/* Experience Section */}
      <div className="flex flex-col gap-6 mx-5" id="work">
        <h2 className="scroll-m-20 pb-2 text-3xl md:text-4xl font-bold tracking-tight text-indigo-500 dark:text-white transition-colors first:mt-0">
          Experience
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          <Experience
            index={0}
            company="IBM, Kochi"
            role="Software Developer Intern"
            logo="/images/ibm.png"
            description="Developed a cloud cost-optimization feature to delete the idle AWS EC2 instances in Turbonomic. Implemented multiple frontend features and resolved several bugs using React to improve overall functionality and user experience. Investigated on exporting Turbo-generated Azure SQL actions for Cloudability to surface these action on its UI."
            certificateLink="https://drive.google.com/file/d/1cOUaTc26_sZend0Ieq72K74GZC81tdSH/view?usp=sharing"
          />

          <Experience
            index={1}
            company="Navodita Infotech"
            role="Full Stack Developer Intern"
            logo="/images/internship.png"
            description="Developed core features in a real-time chat app, including user authentication, message search, typing indicators, file sharing and user online status. Reduced client-side load times by implementing lazy loading and optimized data fetching techniques. Enhanced user experience with modern UI components and responsive design, improving satisfaction."
            certificateLink="https://drive.google.com/file/d/1L3MvBk3wxTpm4ak0A7OAF5wfilwTfxY_/view?usp=sharing"
          />
        </div>
      </div>

      {/* Decorative Background */}
      <div className="absolute inset-x-0 -z-10 -top-36 transform-gpu overflow-hidden blur-3xl sm:-top-80" aria-hidden="true">
        <div
          className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 dark:opacity-10 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
          style={{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)'
          }}
        />
      </div>
    </div>
  );
};

export default About;
